// Ported 1:1 from the Webflow page markup (scraped/). Class names and data-w-id
// attributes must stay intact: webflow.css and the IX2/Lottie runtime key off them.
import { useCurrent } from "@/lib/webflow";

export default function Navbar() {
  const cur = useCurrent();
  return (
    <div data-w-id="9c896d19-12ed-148e-4e5a-1c014986d7c2" data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" className="navbar w-nav">
      <div className="nav-block">
        <div className="nav">
          <a href="/" className={cur("/", "brand w-nav-brand")}>
            <img src="/assets/cdn/655ccb07963af7dd90c4154e_Abilitics%20Logo.svg" loading="eager" alt="Abilitics" className="logo" />
          </a>
          <nav role="navigation" className="nav-menu w-nav-menu">
            <a href="/" className={cur("/", "nav-link w-nav-link")}>Home</a>
            <a href="/for-founders" className={cur("/for-founders", "nav-link w-nav-link")}>For Founders</a>
            <a href="/ventures" className={cur("/ventures", "nav-link w-nav-link")}>Ventures</a>
            <a href="/blog" className={cur("/blog", "nav-link w-nav-link")}>Blog</a>
            <a href="/about-us" className={cur("/about-us", "nav-link w-nav-link")}>About us</a>
            <a href="/contact" className={cur("/contact", "nav-link onlydesktop w-nav-link")}>Contact</a>
          </nav>
          <div className="menu-button w-nav-button">
            <div className="icon-menu w-icon-nav-menu" />
          </div>
          <div className="loginholder">
            <a role="button" href="/contact" className="body-button-4 no-bg footer-buttons outlinegreenbtn no-margin-bottom loginbtn w-inline-block">
              <div className="text-block-259 bluetext">Contact</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
